import styled from 'styled-components'

export const CardContainer = styled.div`
	background: linear-gradient(135deg, #1f2937 0%, #111827 50%, #0f172a 100%);
	border: 1px solid rgba(99, 102, 241, 0.3);
	border-radius: 15px;
	width: 370px;
	min-width: 370px;
	max-width: 370px;
	min-height: 140px;
	padding: 25px 30px;
	box-shadow: 
		0px 8px 25px rgba(0, 0, 0, 0.4),
		0px 0px 0px 1px rgba(99, 102, 241, 0.25),
		0px 0px 20px rgba(99, 102, 241, 0.2);
	transition: 0.3s ease;
	
	&:hover {
		box-shadow: 
			0px 12px 35px rgba(99, 102, 241, 0.3),
			0px 0px 0px 1px rgba(99, 102, 241, 0.4),
			0px 0px 30px rgba(99, 102, 241, 0.25);
		border-color: rgba(99, 102, 241, 0.5);
		background: linear-gradient(135deg, #1f2937 0%, #111827 30%, #0f172a 100%);
	}
	
	@media (max-width: 768px) {
		width: 95%;
		min-width: 320px;
		max-width: 400px;
		min-height: auto;
		padding: 20px;
		box-shadow: 
			0px 6px 20px rgba(0, 0, 0, 0.3),
			0px 0px 0px 1px rgba(99, 102, 241, 0.2),
			0px 0px 15px rgba(99, 102, 241, 0.15);
	}
	
	@media (max-width: 480px) {
		width: calc(100% - 20px);
		min-width: 280px;
		max-width: none;
		padding: 16px;
		margin: 0 10px;
	}
`

export const TitleWrapper = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 14px;
	
	@media (max-width: 700px) {
		margin-bottom: 0;
	}
`

export const Content = styled.div`
	font-weight: 700;
	font-size: 30px;
	color: #e5e7eb;
	
	/* Для многострочного контента убираем большой размер шрифта */
	div {
		font-size: 16px;
		font-weight: 400;
	}
	
	@media (max-width: 700px) {
		font-size: 24px;
		
		div {
			font-size: 14px;
		}
	}
`

export const Title = styled.h3`
	font-weight: 600;
	font-size: 24px;
	margin: 0 0 24px 0;
	color: #e5e7eb;
	text-align: center;
	
	@media (max-width: 768px) {
		font-size: 22px;
		margin: 0 0 20px 0;
	}
	
	@media (max-width: 480px) {
		font-size: 20px;
		margin: 0 0 16px 0;
	}
`
